import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const ProductionOrderSummaryViewModule = new Module({
  id: 'REPORT-PROD-ORDER-SUMMARY:VIEW:*',
  name: 'Production Order Summary',
  label: 'Production Order Summary',
  path: 'production-order-summary',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/ProductionOrderSummary'))
  ),
  actions: {
    viewOrderDetails: {
      id: 'REPORT-PROD-ORDER-SUMMARY:VIEW:DETAILS',
      name: 'view-details',
      label: 'View Details'
    }
  }
});

const ProductionOrderSummaryModules = [ProductionOrderSummaryViewModule];

export default new ModuleBundle(
  'ProductionOrderSummary',
  ProductionOrderSummaryModules
);
